// currentScreenDataReducer.js

export const currentScreenDataActions = {
    SET_DATA: 'SET_DATA',
    RESET: 'RESET',
};

export const initialCurrentScreenDataState = {
    formFields: [],
    tableFields: [],
};

const currentScreenDataReducer = (state = initialCurrentScreenDataState, action) => {
    switch (action.type) {
        case currentScreenDataActions.SET_DATA:
            return {
                ...state,
                ...action.payload,
            };
        case currentScreenDataActions.RESET:
            return initialCurrentScreenDataState;
        default:
            return state;
    }
};

export default currentScreenDataReducer;
